import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client/core"

const httpLink = createHttpLink({
  uri: "/graphql",
  credentials: "same-origin",
})

export const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
})
